module.exports = __webpack_public_path__ + "img/apendiev_500.afcae082.jpg";